module.exports = __webpack_public_path__ + "img/news7.43a43942.svg";